import React from "react";
import { image_path_server } from "../../../../../config";

const Imagen = ({ data, cab, hijos, campokey, id_elemento, valor }) => {
  const nombre = (() => {
    if (cab.nombre_alias) {
      return data[cab.nombre_alias];
    }
    return cab.nombre;
  })();

  const rawImagen = valor ?? data[cab.id_a] ?? data[campokey];

  const src = (() => {
    if (!rawImagen) return "";

    const imagen = String(rawImagen).trim();

    if (
      imagen.startsWith("http://") ||
      imagen.startsWith("https://") ||
      imagen.startsWith("data:") ||
      imagen.startsWith("blob:")
    ) {
      return imagen;
    }

    const base = String(image_path_server || "").replace(/\/$/, "");
    const path = imagen.replace(/^\//, "");

    return `${base}/${path}`;
  })();

  return (
    <div id={id_elemento} style={{ width: "100%", textAlign: cab.align }} className={cab.className}>
      {nombre ? (
        <div className="vista_label" style={{ fontWeight: "bold" }}>
          {nombre}:
        </div>
      ) : null}

      {src ? (
        <img
          src={src}
          style={{ textAlign: cab.align }}
          alt={`${cab.nombre || ""} ${campokey}`}
          width={cab.image_width}
        />
      ) : null}

      {hijos}
    </div>
  );
};

export default Imagen;
